export default function IconSend({width="11.967"}) {
    const aspectRatio = 10.487 / 11.967;
    const height = width * aspectRatio;

    return <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 11.967 10.487">
        <path id="send" d="M-4.65-9.661A.937.937,0,0,0-5.857-8.37L-4.38-5.529a.679.679,0,0,0,.516.359l4.1.513A.159.159,0,0,1,.375-4.5a.159.159,0,0,1-.141.157l-4.1.513a.679.679,0,0,0,.516.359L-5.857-.63A.938.938,0,0,0-4.648.661l10.2-4.474a.75.75,0,0,0,0-1.373L-4.65-9.661Z" transform="translate(5.966 9.744)" fill="#9a1b7d"/>
    </svg>
}
